import { AiOutlineArrowLeft } from "react-icons/ai";
import CustomSvg from "../components/svgs/CustomSvg";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGames } from "../utils/hooks";
import { patchRequest } from "../components/apiRequests/requestApi";
import { toast } from "react-toastify";
import GateFeeModal from "./gateFee";

const SetWinnings = () => {
  const { games, getGames } = useGames();
  const { winners: winnersParam, gameId, tournamentId } = useParams();
  const [winnerAmounts, setWinnerAmounts] = useState([]);
  const [winners, setWinners] = useState(0);
  const [totalWinnings, setTotalWinnings] = useState(0);
  const [showGateFeeModal, setShowGateFeeModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getGames();
    if (winnersParam) setWinners(parseInt(winnersParam));
  }, [winnersParam]);

  const totalAssigned = winnerAmounts.reduce((acc, val) => acc + (val || 0), 0);
  const remainingAmount = totalWinnings - totalAssigned;

  const updateWinnerAmount = (index, value) => {
    const updated = [...winnerAmounts];
    value = Math.max(0, value);
    const currentTotalExcludingThis =
      totalAssigned - (winnerAmounts[index] || 0);
    const allowed = Math.max(0, totalWinnings - currentTotalExcludingThis);
    updated[index] = Math.min(value, allowed);
    setWinnerAmounts(updated);
  };

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const submitPrizes = async ({ hasGateFee, gateFee }) => {
    const url = `/celebrity/tournament/${tournamentId}/prizes`;
    const payload = {
      prizes: winnerAmounts.map((amount) => (amount || 0) * 100),
      hasGateFee,
      gateFee: hasGateFee ? gateFee : 0,
    };

    try {
      const response = await patchRequest({ url, detail: payload });
      toast.success(hasGateFee ? "Gate fee set!" : "No gate fee was set");

      if (response) {
        navigate(`/game/tournament/${tournamentId}/code`);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to submit prizes.");
      // console.error("Prize submission error:", error);
    }
  };

  return (
    <div className="bg-[#130828] min-h-svh p-3">
      <div className="relative flex items-center justify-center py-10">
        <div className="absolute -left-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent text-center">
          Host Game
        </h2>
      </div>

      <div className="justify-center mx-auto mb-4">
        <label className="text-white font-medium block mb-2">
          Total Winnings
        </label>
        <input
          type="text"
          value={totalWinnings.toLocaleString()}
          onChange={(e) => {
            const value = parseInt(e.target.value.replace(/,/g, '')) || 0;
            setTotalWinnings(Math.max(0, value));
          }}
          className="w-full p-2 rounded text-white  placeholder-white placeholder-opacity-100  text-lg"
          placeholder="Enter total winnings"
        />
        <p className="text-sm text-white mt-1">Remaining: {remainingAmount.toLocaleString()}</p>
      </div>

      <div className="flex flex-col gap-6 max-w-md mx-auto mb-8">
        {winners > 0 &&
          Array.from({ length: winners }, (_, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-between gap-4  px-4 py-2 rounded-lg"
            >
                <span className="text-white capitalize w-24">
                {getOrdinal(index + 1)} Winner
              </span>
              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    updateWinnerAmount(index, (winnerAmounts[index] || 0) - 1)
                  }
                  className="bg-white text-[#BD3193] w-8 h-8 rounded-full flex items-center justify-center text-lg"
                  disabled={(winnerAmounts[index] || 0) <= 0}
                >
                  −
                </button>
                <input
                  type="text"
                  value={(winnerAmounts[index] || 0).toLocaleString()}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/,/g, '');
                    updateWinnerAmount(index, parseInt(raw) || 0);
                  }}
                  className="w-28 p-2 text-lg rounded text-center text-white  placeholder-white placeholder-opacity-100"
                />
                <button
                  onClick={() =>
                    updateWinnerAmount(index, (winnerAmounts[index] || 0) + 1)
                  }
                  className="bg-white text-[#BD3193] w-8 h-8 rounded-full flex items-center justify-center text-lg"
                  disabled={remainingAmount <= 0}
                >
                  +
                </button>
              </div>
            </div>
          ))}
      </div>

      <button
        onClick={() => {
          setLoading(true);
          setTimeout(() => {
            setShowGateFeeModal(true);
            setLoading(false);
          }, 300);
        }}
        disabled={loading}
        className={`my-5 py-3 w-full text-lg text-white rounded-lg transition-colors ${
          loading
            ? "bg-gray-500 cursor-not-allowed"
            : "bg-[#56920D] hover:bg-[#3F9217]"
        }`}
      >
        {loading ? "Loading..." : "NEXT"}
      </button>

      <GateFeeModal
        isOpen={showGateFeeModal}
        onClose={() => setShowGateFeeModal(false)}
        onSuccess={() => console.log("Gate fee set successfully")}
        tournamentId={tournamentId}
        prizes={winnerAmounts}
        hasGateFee={true}
        gateFee={0}
        gameId={gameId}
        submitPrizes={submitPrizes}
      />
    </div>
  );
};

export default SetWinnings;
